import { useRef, useState } from "react";
import PropTypes from "prop-types";
import CategoryHeaderContent from "./CategoryHeaderContent";
import CategoryHeaderMedia from "./CategoryHeaderMedia";
import CategoryHeaderTitleOverlay from "./CategoryHeaderTitleOverlay";
import { VIDEO_HEADER } from "../../../../constants";
import { LARGE_VIEWPORT } from "../../../../../state/modules/layout/constants";
import { getHeaderTitle } from "../../../helpers.js";
import styles from "./CategoryHeaderHero.css";

const CategoryHeaderHero = ({ category, scrollFunction, viewportCategory }) => {
  const videoRef = useRef(null);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const {
    id,
    headerTitle,
    friendlyName,
    headerBody,
    headerHtmlEncoded
  } = category;
  const header = getHeaderTitle({
    headerTitle,
    friendlyName,
    headerHtmlEncoded
  });

  const toggleDescription = () => {
    viewportCategory !== LARGE_VIEWPORT &&
      setIsDescriptionOpen(!isDescriptionOpen);
  };

  return (
    <div id={VIDEO_HEADER} className={styles.heroHeader}>
      <div className={styles.heroHeaderContainer}>
        <CategoryHeaderMedia
          ref={videoRef}
          viewportCategory={viewportCategory}
          categoryId={id}
        />
        <CategoryHeaderTitleOverlay
          headerTitle={header}
          scrollFunction={scrollFunction}
        />
      </div>
      {category.headerBody && (
        <CategoryHeaderContent
          viewportCategory={viewportCategory}
          content={headerBody}
          toggleDescription={toggleDescription}
          isDescriptionOpen={isDescriptionOpen}
        />
      )}
    </div>
  );
};

CategoryHeaderHero.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    headerBody: PropTypes.string,
    friendlyName: PropTypes.string,
    headerHtmlEncoded: PropTypes.string,
    headerTitle: PropTypes.string
  }).isRequired,
  scrollFunction: PropTypes.func.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default CategoryHeaderHero;
